var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"21"}})}
var staticRenderFns = []

export { render, staticRenderFns }